<template>
  <div>
    <section>
      <b-row class="content-header">
        <b-col
          class="content-header-left mb-2"
          cols="12"
          md="9"
        >
          <b-row class="breadcrumbs-top">
            <b-col cols="12">
              <h2 class="content-header-title float-left pr-1 mb-0">
                Shortcodes
              </h2>
              <div class="breadcrumb-wrapper">
                <b-breadcrumb>
                  <b-breadcrumb-item to="/">
                    <feather-icon
                      icon="HomeIcon"
                      size="16"
                      class="align-text-top"
                    />
                  </b-breadcrumb-item>
                  <b-breadcrumb-item active>
                    Manage
                  </b-breadcrumb-item>
                </b-breadcrumb>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          class="content-header-right text-md-right d-md-block d-none mb-1"
          md="3"
          cols="12"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="add_shortcode"
          >
            Link generator
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-card
            v-if="shortcodes.length"
            no-body
            class="card-company-table"
          >
            <b-table
              :per-page="pagination.perPage"
              :current-page="pagination.currentPage"
              :items="shortcodes"
              responsive
              hover
              :fields="fields"
              class="mb-0"
            >
              <template #cell(code)="data">
                <div class="d-flex align-items-center">
                  <span class="text-primary">{{ shortener_url }}/{{ data.item.code }}</span>
                  <b-avatar
                    v-b-tooltip.hover.top="'Copy URL'"
                    class="ml-1 cursor-pointer"
                    variant="light-primary"
                    size="32"
                    @click.native="copy(data.item.code)"
                  >
                    <mdicon
                      name="content-copy"
                      size="20"
                    />
                  </b-avatar>
                  <b-avatar
                    v-b-tooltip.hover.top="'QR code'"
                    class="ml-1 cursor-pointer"
                    variant="light-primary"
                    size="32"
                    @click.native="qrcode(data.item.code)"
                  >
                    <mdicon
                      name="qrcode"
                      size="20"
                    />
                  </b-avatar>
                </div>
              </template>

              <template #cell(url)="data">
                <div class="d-flex align-items-center">
                  <span>{{ data.item.url }}</span>
                </div>
              </template>

              <template #cell(note)="data">
                {{ data.item.note }}
              </template>

              <template #cell(action)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item @click="edit(data.item)">
                    <feather-icon
                      icon="Edit2Icon"
                      class="mr-50"
                    />
                    <span>Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="destroy(data.item.id)">
                    <feather-icon
                      icon="TrashIcon"
                      class="mr-50"
                    />
                    <span>Delete</span>
                  </b-dropdown-item>
                </b-dropdown>

              </template>
            </b-table>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.totalRows"
              :per-page="pagination.perPage"
              align="center"
              size="sm"
              class="my-1"
            />
          </b-card>
        </b-col>
      </b-row>
    </section>
    <b-modal
      v-model="showEdit"
      centered
      title="Update Shortcode"
      ok-title="Update Note"
      @ok="update_shortcode"
    >
      Update note for link <a
      :href="selected.url"
      target="_blank"
    >{{ selected.url }}</a>
      <b-form-input
        id="description"
        v-model="selected.note"
        class="my-1"
        required
      />
    </b-modal>
    <b-modal
      v-model="showAdd"
      centered
      title="Generate Link"
      ok-title="Generate"
      :ok-disabled="$v.newShortcode.$invalid"
      @ok="generate_shortcode"
    >
      <b-form-group
        label="Site for tracking redirects"
        label-for="idsite-short"
      >
        <b-form-select
          id="idsite-short"
          v-model="newShortcode.idsite"
          :options="$store.state.app.allSites"
          value-field="idsite"
          text-field="label"
          clearable
        />
      </b-form-group>
      <b-form-group
        label="Provide URL to be shortened"
        label-for="url"
        description="ex. https://hostmatic.io"
      >
        <b-form-input
          id="url"
          v-model="newShortcode.url"
          required
        />
      </b-form-group>
      <b-form-group
        label="Note"
        label-for="note"
      >
        <b-form-input
          id="note"
          v-model="newShortcode.note"
        />
      </b-form-group>
    </b-modal>
    <b-modal
      v-model="showQR"
      centered
      :title="modal_title"
    >
      <div class="text-center">
        <div id="qr-code"/>
      </div>
      <template #modal-footer>
        <b-button size="sm" variant="primary" @click="download">Download</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import QRCodeStyling from 'qr-code-styling'
import { required, url } from 'vuelidate/lib/validators'
import { initPagination } from '@/libs/helpers'
import api from '@/libs/axios'
import { hmError, hmSuccess } from '@/libs/toastification'
import store from '@/store'

export default {
  data() {
    return {
      shortcodes: [],
      fields: [
        {
          key: 'code',
          label: 'LINK'
        },
        {
          key: 'url',
          label: 'Destination'
        },
        {
          key: 'note',
          label: 'NOTE'
        },
        {
          key: 'action',
          label: 'ACTION'
        }
      ],
      pagination: initPagination(),
      showEdit: false,
      showAdd: false,
      showQR: false,
      selected: {},
      newShortcode: {
        idsite: 1,
        url: null,
        note: null
      },
      shortener_url: null,
      options: {
        width: 300,
        height: 300,
        data: 'https://qr-code-styling.com',
        margin: 0,
        qrOptions: {
          typeNumber: '0',
          mode: 'Byte',
          errorCorrectionLevel: 'Q'
        },
        imageOptions: {
          hideBackgroundDots: true,
          imageSize: 0.4,
          margin: 0
        },
        dotsOptions: {
          type: 'square',
          color: '#000000'
        },
        backgroundOptions: { color: '#ffffff' },
        image: require('@/assets/images/ico/favicon.png'),
        dotsOptionsHelper: {
          colorType: {
            single: true,
            gradient: false
          },
          gradient: {
            linear: true,
            radial: false,
            color1: '#6a1a4c',
            color2: '#6a1a4c',
            rotation: '0'
          }
        },
        cornersSquareOptions: {
          type: 'extra-rounded',
          color: '#7367f0'
        },
        cornersSquareOptionsHelper: {
          colorType: {
            single: true,
            gradient: false
          },
          gradient: {
            linear: true,
            radial: false,
            color1: '#000000',
            color2: '#000000',
            rotation: '0'
          }
        },
        cornersDotOptions: {
          type: '',
          color: '#000000'
        },
        cornersDotOptionsHelper: {
          colorType: {
            single: true,
            gradient: false
          },
          gradient: {
            linear: true,
            radial: false,
            color1: '#000000',
            color2: '#000000',
            rotation: '0'
          }
        },
        backgroundOptionsHelper: {
          colorType: {
            single: true,
            gradient: false
          },
          gradient: {
            linear: true,
            radial: false,
            color1: '#ffffff',
            color2: '#ffffff',
            rotation: '0'
          }
        }
      },
      modal_title: null,
      qrCode: null,
      modal_code: null
    }
  },
  validations: {
    newShortcode: {
      idsite: { required },
      url: {
        required,
        url
      }
    }
  },
  mounted() {
    this.get_shortcodes()
  },
  methods: {
    get_shortcodes() {
      api.post('/api/matomo/shortcodes/get_shortcodes')
        .then(r => {
          if (r.data.code !== 'Ok') return hmError('Error reading Links')
          this.shortcodes = r.data.shortcodes
          this.shortener_url = r.data.shortener_url.setting_value
          this.pagination.totalRows = this.shortcodes.length
        })
        .catch(e => {
          hmError('Error reading Links')
          console.error(e)
        })
    },
    edit(row) {
      this.selected = { ...row }
      this.showEdit = true
    },
    update_shortcode() {
      api.post('/api/matomo/shortcode/update', this.selected)
        .then(r => {
          if (r.data.code !== 'Ok') return hmError('Error updating link note')
          const f = this.shortcodes.find(s => s.id === this.selected.id)
          f.note = this.selected.note
          hmSuccess('Link note update successful')
          this.showEdit = false
        })
        .catch(e => {
          hmError('Error updating link note')
          console.error(e)
        })
    },
    destroy(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      })
        .then(result => {
          if (result.value) {
            api.post('/api/matomo/shortcode/destroy', { id })
              .then(r => {
                if (r.data.code !== 'Ok') return hmError('Error deleting link')
                hmSuccess('Link delete successful')
                this.get_shortcodes()
              })
              .catch(e => {
                hmError('Error deleting Link')
                console.error(e)
              })
          }
        })
    },
    add_shortcode() {
      this.newShortcode.idsite = store.state.app.allSites[0].idsite
      this.newShortcode.url = this.newShortcode.note = null
      this.showAdd = true
    },
    generate_shortcode() {
      api.post('/api/matomo/shortcode/generate', { shortcode: this.newShortcode })
        .then(r => {
          if (r.data.code === 'invalid') return hmError('Unable to generate link')
          if (r.data.code !== 'Ok') return hmError('Error generating new link')
          hmSuccess('Shortcode generated successful')
          this.get_shortcodes()
        })
    },
    copy(code) {
      this.$copyText(`${this.shortener_url}/${code}`)
        .then(() => hmSuccess('URL copied'))
    },
    qrcode(code) {
      this.options.data = `${this.shortener_url}/${code}`
      this.qrCode = new QRCodeStyling(this.options)
      this.modal_title = `Shortcode ${code}`
      this.modal_code = code
      this.showQR = true
      this.$nextTick(() => {
        this.qrCode.append(document.getElementById('qr-code'))
      })
    },
    download() {
      this.qrCode.download({
        name: this.modal_code,
        extension: 'svg'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';
</style>
